var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#425b72;}.cls-2{fill:#f8834b;}.cls-3{fill:#6fabe6;}.cls-4{fill:#82bcf4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Blockchain money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blockchain_money",
    "data-name": "Blockchain money"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.35,42.57a1,1,0,0,1-.48-1.87l9.65-5.35a1,1,0,0,1,1,1.75C28.13,42.84,28.73,42.57,28.35,42.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,42.77c-.38,0,.34.33-10.83-5.86a1,1,0,0,1,1-1.75l10.35,5.73A1,1,0,0,1,20,42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,12.2a1,1,0,0,1-.49-1.87l7.58-4.2a1,1,0,0,1,1,1.75C10.88,12.43,11.41,12.2,11,12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,12.77c-.37,0,.42.38-10.13-5.47a1,1,0,0,1,1-1.75l9.65,5.35A1,1,0,0,1,38,12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,29V19a1,1,0,0,1,2,0V29A1,1,0,0,1,41,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,29V19a1,1,0,0,1,2,0V29A1,1,0,0,1,5,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,23a1,1,0,1,1,1-1,1,1,0,0,0,1,1c1.66,0,1.21-3-1-3.82a1,1,0,1,0-2,0A3,3,0,0,0,24,25a1,1,0,1,1-1,1,1,1,0,0,0-1-1c-1.66,0-1.21,3,1,3.82a1,1,0,1,0,2,0A3,3,0,0,0,24,23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30 3.4 24 5.8 18 3.4 24 1 30 3.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24 5.8 24 13 18 10.6 18 3.4 24 5.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30 3.4 30 10.6 24 13 24 5.8 30 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13,11.4,7,13.8,1,11.4,7,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,13.8V21L1,18.6V11.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13 11.4 13 18.6 7 21 7 13.8 13 11.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.5 2.4 24 3.8 20.5 2.4 24 1 27.5 2.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23 5.4 23 9.6 18 7.6 18 3.4 23 5.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "30 3.4 30 7.6 25 9.6 25 5.4 30 3.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13 29.4 7 31.8 1 29.4 7 27 13 29.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7 31.8 7 39 1 36.6 1 29.4 7 31.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13 29.4 13 36.6 7 39 7 31.8 13 29.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47 11.4 41 13.8 35 11.4 41 9 47 11.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41 13.8 41 21 35 18.6 35 11.4 41 13.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47 11.4 47 18.6 41 21 41 13.8 47 11.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47 29.4 41 31.8 35 29.4 41 27 47 29.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41 31.8 41 39 35 36.6 35 29.4 41 31.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47 29.4 47 36.6 41 39 41 31.8 47 29.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30 37.4 24 39.8 18 37.4 24 35 30 37.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24 39.8 24 47 18 44.6 18 37.4 24 39.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30 37.4 30 44.6 24 47 24 39.8 30 37.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "44.5 10.4 41 11.8 37.5 10.4 41 9 44.5 10.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "40 13.4 40 17.6 35 15.6 35 11.4 40 13.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "47 11.4 47 15.6 42 17.6 42 13.4 47 11.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "44.5 28.4 41 29.8 37.5 28.4 41 27 44.5 28.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "40 31.4 40 35.6 35 33.6 35 29.4 40 31.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "47 29.4 47 33.6 42 35.6 42 31.4 47 29.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.5 36.4 24 37.8 20.5 36.4 24 35 27.5 36.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23 39.4 23 43.6 18 41.6 18 37.4 23 39.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "30 37.4 30 41.6 25 43.6 25 39.4 30 37.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.5 28.4 7 29.8 3.5 28.4 7 27 10.5 28.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "6 31.4 6 35.6 1 33.6 1 29.4 6 31.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13 29.4 13 33.6 8 35.6 8 31.4 13 29.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.5 10.4 7 11.8 3.5 10.4 7 9 10.5 10.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "6 13.4 6 17.6 1 15.6 1 11.4 6 13.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13 11.4 13 15.6 8 17.6 8 13.4 13 11.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9d86f8ac9680dc60aeeb937ab15ee381.svg";
export { ForwardRef as ReactComponent };